import { push } from 'connected-react-router';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

export const useConnectedRouter = () => {
    const dispatch = useDispatch();

    const onPush = useCallback((path) => {
        dispatch(push(path));
    }, [dispatch]);

    return { onPush };
};
